import GetOrder from './GetOrder';

export default GetOrder;
